import CloseIcon from "@mui/icons-material/Close";
import { Box, BoxProps, IconButton, IconButtonProps } from "@mui/material";
import DialogTitleMui, {
  DialogTitleProps as DialogTitlePropsMui,
} from "@mui/material/DialogTitle";
export interface DialogTitleProps extends DialogTitlePropsMui {
  onClose?: Function;
  closeButtonProps?: IconButtonProps;
  titleBoxProps?: BoxProps;
}
export default function DialogTitle({
  onClose,
  children,
  closeButtonProps,
  titleBoxProps,
  ...props
}: DialogTitleProps) {
  if (!onClose) {
    <DialogTitleMui {...props}>{children}</DialogTitleMui>;
  }
  return (
    <DialogTitleMui {...props}>
      <Box display="flex" alignItems="center">
        <Box flexGrow={1} {...titleBoxProps}>
          {children}
        </Box>
        {onClose && (
          <Box>
            <IconButton
              onClick={() => onClose && onClose()}
              {...closeButtonProps}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        )}
      </Box>
    </DialogTitleMui>
  );
}
